import ButtonControl from '../button-control'

const TeamNotesButtons = ({ isLoading, onSaveChanges, onCancel }) =>
  <div class='team-notes__buttons'>
    <ButtonControl
      variant='success'
      title='Save changes'
      isLoading={isLoading}
      onClick={onSaveChanges}
      class='qa-save-notes'
    />
    <ButtonControl
      title='Cancel'
      onClick={onCancel}
    />
  </div>

export default TeamNotesButtons
